module.exports = __webpack_public_path__ + "img/leumicard-max.3050e7c0.png";